import { gql } from '@apollo/client';

export const EXTEND_POST = gql`
  mutation ExtendPost($postId: ID!, $postType: String!) {
    extendPost(postId: $postId, postType: $postType) {
      success
      newExpiresAt
      extensionCount
      error
    }
  }
`;
